module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-Manchester-logo-fb5ca304a02c05693e116113bccb4eb8.svg";